import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LangService {
  supportLanguages = ['en', 'ar'];
  defaultLang = 'en';

  constructor(
    private translateService: TranslateService
  ) { }

  public getAndSetLang = new BehaviorSubject<any>('');
  currentLang = this.getAndSetLang.asObservable();

  
}
